import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=bb65867a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=bb65867a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb65867a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb65867a')) {
      api.createRecord('bb65867a', component.options)
    } else {
      api.reload('bb65867a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=bb65867a&scoped=true&", function () {
      api.rerender('bb65867a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sXgJmg14rNec/JS/comp/CookieBox.vue"
export default component.exports